import * as React from "react";
import * as cn from "classnames";

export interface AccordionCardComponentProps {
    bodyClassName?: string;
    className?: string;
    cardHeader?: string;
    children: React.ReactChild | React.ReactChild[];
    isOpen?: boolean;
    isSummary?: boolean;
}

export class AccordionCardComponent extends React.Component<AccordionCardComponentProps, any> {
    constructor(props: AccordionCardComponentProps) {
        super(props);
        this.state = {
            isOpen: !!this.props.isOpen
        };
    }

    toogleCardBody() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const { cardHeader, bodyClassName, className, isSummary } = this.props;
        const { isOpen } = this.state;

        if (isSummary) {
            return (
                <div className={cn("card", className)}>
                    <div className={cn("card-header-summary")}>
                        <h4>{cardHeader}</h4>
                    </div>
                    <div className={cn("card-body", bodyClassName, isOpen ? "active" : "")}>{this.props.children}</div>
                </div>
            );
        }

        return (
            <div className={cn("card", className)}>
                <div className={cn("card-header", isOpen ? "active" : "")} onClick={_ => this.toogleCardBody()}>
                    <h4>{cardHeader}</h4>
                    <span className="open-icon" />
                </div>
                <div className={cn("card-body", bodyClassName, isOpen ? "active" : "")}>{this.props.children}</div>
            </div>
        );
    }
}
